export default {
  namespaced: true,
  state: {
    startPlaceInfo: {},
    endPlaceInfo: {},
    voyageInfo: {},
    ticketInfo: {}, // 出票记录通过openUrl页面请求接口需要传递的参数
    refundInfo: {} // 退票记录通过openUrl页面请求接口需要传递的参数
  },
  mutations: {
    // 清空起点和终点数据
    INIT_PLACE(state) {
      state.startPlaceInfo = {}
      state.endPlaceInfo = {}
    },
    // 设置起点数据
    SET_START_PLACE(state, data) {
      state.startPlaceInfo = data || {}
      window.localStorage.setItem('startPlaceData', JSON.stringify(data))
    },
    // 设置终点数据
    SET_END_PLACE(state, data) {
      state.endPlaceInfo = data || {}
      window.localStorage.setItem('endPlaceData', JSON.stringify(data))
    },
    INIT_VOYAGE_INFO(state) {
      state.voyageInfo = {}
    },
    // 设置航班信息
    SET_VOYAGE_INFO(state, data) {
      state.voyageInfo = data
    },
    // 出票记录通过openUrl页面请求接口需要传递的参数
    SET_TICKET_INFO(state, data) {
      state.ticketInfo = data
    },
    // 退票记录通过openUrl页面请求接口需要传递的参数
    SET_REFUND_INFO(state, data) {
      state.refundInfo = data
    },
    // 清除出票记录通过openUrl页面请求接口需要传递的参数
    REMOVE_TICKET_INFO(state) {
      state.ticketInfo = {}
    },
    // 清除退票记录通过openUrl页面请求接口需要传递的参数
    REMOVE_REFUND_INFO(state) {
      state.refundInfo = {}
    }
  }
}
